export default __webpack_public_path__ + "static/mark-374220f45219286e2498d691c8db7814.jpg";